import _ from 'lodash';
import Money from '../../libs/money';

export const getApplicableVatCodes = (currentCompany, customerCountry) => {
  if (currentCompany.vatPeriod === 'EXEMPTED') {
    return ['V-NL-E'];
  }
};

export const calculateVatAmount = (amount, vatCode) => {
  if (!amount || !vatCode) return 0;
  const vatPercentage = vatCode.percentage;
  return Money(amount).times(vatPercentage).div(100).toNumber();
};

export const calculateLineAmounts = (line, invoice) => {
  const { vatCode } = line;

  let quantity = line.quantity || 1;
  if(isNaN(line.quantity)) {
    quantity = 1;
  }
  let price = line.price || 0;
  if(isNaN(price)) {
    price = 0;
  }

  const amount = (line.quantity || line.price) ? (quantity * price) : (line.amount || 0);
  if (!vatCode) {
    return {amount};
  }
  const vatAmount = calculateVatAmount(amount, vatCode, invoice.invoiceDate);
  const vatPercentage = vatCode.percentage;
  const amountIncludingVat = Money(amount).plus(vatAmount).toNumber();
  return {
    vatCode,
    amount,
    vatAmount,
    vatPercentage,
    amountIncludingVat,
  };
};

const getSubtotalAmount = (invoice) => {
  const subtotal = invoice.Lines.reduce((total, line) => total.plus(line.amount || 0), Money(0));
  return subtotal.toNumber();
};

const getTotalVatAmounts = (invoice) => {
  const lines = invoice.Lines.filter(line => !!line.vatCode);
  const totals = _(lines).groupBy('vatCodeId').map((objs, vatCodeId) => ({
    vatCodeId,
    displayName:  objs[0].vatCode.displayName,
    percentage: objs[0].vatCode.percentage,
    amount: _.sumBy(objs, 'vatAmount') || 0 }))
    .value();
  return totals;
};

const getTotalVatAmount = (invoice) => {
  return getTotalVatAmounts(invoice).reduce((total, totalVat) => total.plus(totalVat.amount || 0), Money(0)).toNumber();
};

const getTotalAmount = (invoice) => {
  return Money(getSubtotalAmount(invoice)).plus(getTotalVatAmount(invoice)).toNumber();
};

export const calculateTotalAmounts = (invoice) =>  {
  return {
    totalAmount: getTotalAmount(invoice),
    subtotalAmount: getSubtotalAmount(invoice),
    totalVatAmounts: getTotalVatAmounts(invoice),
    totalVatAmount: getTotalVatAmount(invoice),
  };
};
